/* 孫吳傳・第 8 章：周泰護主（建安初年，196 前後）
 * 史實：《三國志·周泰傳》「權住宣城，使士自衛，不能千人，意尚忽略，不治圍落，而山賊數千人卒至。權始得上馬，而賊鋒刃已交於左右，
 *       或斫中馬鞍，衆莫能自定。惟泰奮激，投身衛權，膽氣倍人，左右由泰並能就戰。賊既解散，身被十二創，良久乃蘇。」
 * 流程：夜裡山賊從四條山路摸進沒有圍籬的營地，一半直撲孫權。操作周泰護住孫權（倒下即戰敗）；
 *       左右的護衛嚇得不敢動，周泰在身邊時才敢應戰；周泰每挨一記重擊就多一道「創」（護甲上升、移速下降）。撐到賊散即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, TROOPS, rout } from '../kit.ts';
import { CAMP, PATHS } from '../maps/xuancheng.ts';

const LV = 9, HOLD = 120, BRAVE_R = 380;
const FOE = { spec: TROOPS.shanzei, name: '山賊', hp: 400, maxHp: 400, atk: 24, ms: 240 };

export default {
  id: 'sunwu-8', map: 'xuancheng', hero: 'zhoutai',
  title: '第 7 章　周泰護主', year: '建安初年（196 前後）',
  brief: {
    quote: [{ text: '權住宣城，使士自衛，不能千人，意尚忽略，不治圍落，而山賊數千人卒至。', src: '《三國志·吳書·周泰傳》' }],
    text: '孫策平定江東，讓十五歲的弟弟孫權駐守宣城。營地沒有築圍籬，一夜，山賊數千人突然殺到。',
    goals: ['護住孫權', '讓左右的護衛跟著你應戰', '撐到山賊散去'],
  },
  words: { ally: '護衛', foe: '山賊' },
  stars: [
    { text: '孫權的生命保住一半以上', ok: (m) => m.vars.qMin >= 0.5 },
    { text: '如史：身被十二創', ok: (m) => m.vars.wounds >= 12 },
    { text: '護衛折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 山賊卒至
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 120; me.y = CAMP[1] + 40;
        V.wounds = 0; V.qMin = 1; V.hp = me.hp;
        const q = ally(w, 'sunquan', CAMP[0], CAMP[1] - 30, 4);
        q.hold = [CAMP[0], CAMP[1] - 30]; V.q = q;
        V.guards = Array.from({ length: 8 }, (_, i) => { const a = (i / 8) * Math.PI * 2, u = m.recruit(CAMP[0] + Math.cos(a) * 260, CAMP[1] + Math.sin(a) * 180, '護衛'); return u; });
        V.foes = [];
        V.t0 = w.t;
        // 每 12 秒從兩條山路各湧進一批；一半的人直撲孫權
        for (let k = 0; k < 9; k++) m.after(2 + k * 12, () => {
          for (const p of [PATHS[k % 4], PATHS[(k + 2) % 4]]) for (let i = 0; i < 4 + Math.floor(k / 3); i++) {
            const u = m.foe('huangjin', p[0] + (SG.rand() - 0.5) * 200, p[1] + (SG.rand() - 0.5) * 160, FOE);
            u.hunt = i % 2 === 0; u.home = [CAMP[0] + (SG.rand() - 0.5) * 300, CAMP[1] + (SG.rand() - 0.5) * 200];
            V.foes.push(u);
          }
        });
        m.big('山賊來了！');
        m.card('山賊數千人卒至。權始得上馬，而賊鋒刃已交於左右，或斫中馬鞍，衆莫能自定。', '《周泰傳》');
        m.after(3, () => m.line('孫權', '幼平！賊人從四面來了！'));
        m.after(5, () => m.line('周泰', '公子別怕，周泰在此！'));
        m.after(9, () => m.line('提示', `左右的護衛嚇得不敢動，你在他們身邊（${BRAVE_R} 內）才會應戰。孫權倒下就輸了。`));
        m.mark('q', q.x, q.y, '孫權', true, q);
        m.obj('q', '護住孫權');
        m.obj('hold', '');
        m.obj('wound', '身上的創：0');
      },
      tick(m, w) {
        const V = m.vars, left = Math.max(0, Math.ceil(HOLD - (w.t - V.t0)));
        m.get('hold').text = `撐到山賊散去（還有 ${left} 秒）`;
        return left <= 0;
      },
    },
    { // 2. 賊既解散
      enter(m, w) {
        const V = m.vars;
        m.done('q'); m.done('hold'); m.unmark('q');
        rout(m, w, V.foes, PATHS[0]);
        if (V.wounds >= 12) m.card('賊既解散，身被十二創，良久乃蘇。', '《周泰傳》'); else m.line('旁白', `山賊散去。周泰身上 ${V.wounds} 道傷，倒在孫權身旁。`);
        m.after(3, () => m.line('孫權', `幼平……你身上有 ${V.wounds} 道傷！快傳醫！`));
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars, q = V.q;
    if (!me.alive) { m.lose('周泰陣亡'); return; }
    if (!q) return;
    if (!q.alive) { m.lose('孫權遇害'); return; }
    V.qMin = Math.min(V.qMin, q.hp / q.maxHp);
    // 孫權：守在原地，敵人近身才還手
    const I = q.input, near = w.units.find((t) => w.isEnemy(q, t) && SG.gd(t.x, t.y, q.x, q.y) < 160);
    if (near) { I.target = near; I.engage = true; } else { I.target = null; I.engage = false; if (SG.gd(q.x, q.y, q.hold[0], q.hold[1]) > 40) I.moveTo = q.hold.slice(); }
    // 直撲孫權的山賊；周泰擋在前面（離他 200 內）就先打周泰
    for (const u of V.foes) if (u.alive && u.hunt && !u.rout) {
      if (SG.gd(u.x, u.y, me.x, me.y) < 200) continue;
      u.home = [q.x, q.y];
      if (SG.gd(u.x, u.y, q.x, q.y) < 300 && !(u.target && u.target.alive)) { u.target = q; u.think = 0.5; }
    }
    // 衆莫能自定：周泰不在身邊，護衛就嚇得不敢動
    for (const u of V.guards) {
      if (!u.alive) continue;
      const brave = SG.gd(u.x, u.y, me.x, me.y) < BRAVE_R;
      if (!brave) { u.target = null; u.think = 0.35; u.home = u.cower || (u.cower = [u.x, u.y]); }
      else u.cower = null;
      u.scared = !brave;
    }
    // 創：每累積掉一成生命就多一道創，護甲 +2、移速 -3%（最多十二道）
    V.acc = (V.acc || 0) + Math.max(0, V.hp - me.hp);
    if (V.acc >= me.maxHp * 0.1 && V.wounds < 12) {
      V.acc -= me.maxHp * 0.1;
      V.wounds++;
      w.addBuff(me, { id: '創', t: 9999, armor: V.wounds * 2, ms: -0.03 * V.wounds });
      w.dmgEvents.push({ x: me.x, y: me.y - 80, text: `第 ${V.wounds} 創`, team: 0, src: me.id, tgt: me.id });
      m.get('wound').text = `身上的創：${V.wounds}`;
    }
    V.hp = me.hp;
  },
};
